import { BusSchoolIcon } from './BusSchoolIcon';

/**
 * author: GreenTurtwig
 * id 774EC563-DF29-498C-8270-ABB051396687
 * name bus-school
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bus-school.svg
 * tags
 * - Transportation + Road 
 */
export const EducationIcon = BusSchoolIcon;
export default EducationIcon